import { render } from "./AdminMenus.vue?vue&type=template&id=0904cafb&scoped=true"
import script from "./AdminMenus.vue?vue&type=script&lang=js"
export * from "./AdminMenus.vue?vue&type=script&lang=js"

import "./AdminMenus.vue?vue&type=style&index=0&id=0904cafb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0904cafb"]])

export default __exports__